import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';
import { MControlTabScrollDirection } from './MControlTabScroll.types';

type WrapperProps = {
  $direction: MControlTabScrollDirection;
};

export const getJustifyContent = (direction: MControlTabScrollDirection) =>
  direction === MControlTabScrollDirection.Left ? 'flex-start' : 'flex-end';

export const getGradient = (direction: MControlTabScrollDirection, isRTL = false) => {
  const isLeft = direction === MControlTabScrollDirection.Left;
  const angle = isLeft !== isRTL ? '270deg' : '90deg';
  return `linear-gradient(${angle}, rgba(var(--t-brand-bg-color-rgb), 0) 0%, var(--t-brand-bg-color) 100%)`;
};

export const getIconTransform = (direction: MControlTabScrollDirection, isRTL = false) => {
  const isLeft = direction === MControlTabScrollDirection.Left;
  return isLeft !== isRTL ? 'scaleX(-1)' : 'scaleX(1)';
};

export const Wrapper = styled.button<WrapperProps>`
  margin: 0;
  padding: 0;
  border: none;
  display: flex;
  align-items: center;
  width: ${toRem(80)};
  min-width: ${toRem(80)};
  cursor: pointer;
  justify-content: ${props => getJustifyContent(props.$direction)};
  background: ${props => getGradient(props.$direction)};

  [dir='rtl'] & {
    justify-content: ${props => getJustifyContent(props.$direction)};
    background: ${props => getGradient(props.$direction, true)};
  }

  &:focus-visible {
    outline: -webkit-focus-ring-color auto 1px;
  }
`;

export const IconWrapper = styled.div<{ $direction: MControlTabScrollDirection }>`
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--t-color-control-foreground-reverse);
  transform: ${props => getIconTransform(props.$direction)};

  [dir='rtl'] & {
    transform: ${props => getIconTransform(props.$direction, true)};
  }
`;
